import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import smartAudienceService from ".";

// Every query here starts with this key, so a send can refresh them all.
export const SMART_AUDIENCES = "smart-audiences";

type ListOptions = { take?: number; merchantUserId?: number; enabled?: boolean };

// Ready-made SMS audiences, most important first. No retry: until an environment has the API, callers
// fall back to the older hints straight away.
export function useSmartAudiences({ take, merchantUserId, enabled = true }: ListOptions = {}) {
  return useQuery({
    queryKey: [SMART_AUDIENCES, "list", { take, merchantUserId }],
    queryFn: () => smartAudienceService.getAudiences({ Take: take, MerchantUserId: merchantUserId }),
    enabled,
    retry: false,
    staleTime: 60_000,
  });
}

export function useSmartAudienceTemplates(audienceKey?: string) {
  return useQuery({
    queryKey: [SMART_AUDIENCES, "templates", audienceKey],
    queryFn: () => smartAudienceService.getTemplates(audienceKey!),
    enabled: Boolean(audienceKey),
  });
}

const PAGE = 20;

export function useSmartAudienceCustomers(audienceKey: string | undefined, merchantUserId: number | undefined, enabled: boolean) {
  return useInfiniteQuery({
    queryKey: [SMART_AUDIENCES, "customers", audienceKey, merchantUserId],
    queryFn: ({ pageParam = 0 }) =>
      smartAudienceService.getCustomers({ audienceKey: audienceKey!, Skip: pageParam, Count: PAGE, MerchantUserId: merchantUserId }),
    getNextPageParam: (last, pages) => {
      const loaded = pages.reduce((sum, page) => sum + (page.result?.length ?? 0), 0);
      return loaded < (last.count ?? 0) ? loaded : undefined;
    },
    enabled: enabled && Boolean(audienceKey),
  });
}
